{
  "manager": {
    "settings": {
      "title": "Settings"
    },
    "contactInformationForm": {
      "organizationTypeLabel": "Organization Type *",
      "legalOrganizationNameLabel": "Legal Organization Name *",
      "legalOrganizationNamePlaceholder": "Enter the legal name of your organization",
      "taxIdentifierLabel": "Tax Identifier",
      "taxIdentifierDescription": "The tax identification number of the organization. For example, in Canada this is your 9-digit Business Number.",
      "registrationNumberLabel": "Registration Number",
      "registrationNumberDescription": "The identification number given to your organization when registered or incorporated. If different from the Tax Identifier, enter it here.",
      "registrationNumberPlaceholder": "Enter your registration number",
      "supportNameLabel": "Support Name",
      "supportNameInvalidFeedback": "Must be 255 characters or fewer.",
      "supportNameDescription": "Shown to members in Communal under Support.",
      "supportNamePlaceholder": "Enter a support contact name",
      "supportEmailLabel": "Support Email *",
      "supportEmailInvalidFeedback": "Must be an email.",
      "supportEmailPlaceholder": "Enter an email for your organization",
      "supportPhoneLabel": "Support Phone Number *",
      "supportPhoneInvalidFeedback": "This field is required.",
      "websiteLabel": "Website *",
      "websiteInvalidFeedback": "The website must be a valid URL and include http:// or https://.",
      "websiteDescription": "Must be a valid URL.",
      "websitePlaceholder": "Enter your website",
      "organizationDescriptionLabel": "Organization Description *",
      "organizationDescriptionPlaceholder": "Enter a brief description of your organization and what type of products you sell on Communal (if applicable)",
      "selectBusinessTypeOption": "Select Business Type",
      "nonProfitOption": "Non-Profit",
      "companyOption": "Company",
      "individualOption": "Individual",
      "phoneInvalidMessage": "Enter a valid phone number."
    },
    "welcomeEmailSettings": {
      "configuration": "Welcome Email Configuration",
      "enable": "Enable Welcome Email",
      "subject": "Subject",
      "greeting": "Greeting",
      "body": "Body",
      "closing": "Closing",
      "previewEmail": "Preview Email",
      "title": "Welcome Email Settings",
      "entityName": "Settings"
    },
    "appearance": {
      "pageTitle": "Appearance",
      "customLogoTitle": "Custom Logo",
      "uploadLogoLabel": "Upload a Logo *",
      "logoDescription": "Our system will automatically resize your logo to fit the header. If you encounter any issues, please contact support.",
      "logoInvalidFeedback": "This field is required and must be 10MB or less.",
      "currentPreviewLabel": "Current Preview",
      "currentLogoAlt": "Current Logo",
      "newLogoPreviewLabel": "New Logo Preview",
      "logoPreviewAlt": "Logo preview",
      "customLinksTitle": "Custom Links",
      "customLinksDescription": "Add up to 3 custom links that will appear in the member navigation sidebar.",
      "link": "Link",
      "enable": "Enable",
      "linkUrlLabel": "Link URL *",
      "linkUrlDescription": "The URL for link {number}",
      "urlInvalidFeedback": "Please enter a valid URL",
      "linkTextLabel": "Link Text *",
      "linkTextDescription": "The display text for link {number} (max 100 characters)",
      "linkTextInvalidFeedback": "Please enter link text",
      "visitOurSitePlaceholder": "Visit our site",
      "addLink": "Add Link ({count}/3)",
      "saveAllLinks": "Save All Links",
      "customCssTitle": "Custom CSS",
      "cssPreviewHint": "Enter CSS here and preview it on the right.",
      "cssListHint": "Style the ul tag containing the links.",
      "cssLoginHint": "Style the login link in the navbar.",
      "guestNavbar": "Guest Navbar",
      "note": "Note",
      "cssNoteBefore": "Note that some rules may require",
      "cssNoteAfter": "to work. If something doesn't work, or you want to target another element, please contact support.",
      "cssRules": "CSS Rules",
      "hide": "Hide",
      "show": "Show",
      "rules": "Rules",
      "generatedRulesHint": "Generated rules that will be passed as styles to the navbar.",
      "errorUploadingLogo": "Error uploading logo. Please try again later or contact support.",
      "logoEntity": "Logo",
      "errorSavingLogo": "Error saving logo. Please try again.",
      "customCssSaved": "Custom CSS Saved!",
      "errorSavingCss": "Error saving custom CSS. Please try again.",
      "customLinksEntity": "Custom links",
      "errorSavingLinks": "Error saving custom links",
      "importantKeyword": "!important"
    },
    "bookingIndex": {
      "title": "Booking Settings",
      "bookingChecklists": "Booking Checklists",
      "maintenanceMode": "Maintenance Mode"
    },
    "boundaryIndex": {
      "title": "Boundaries"
    },
    "customTextIndex": {
      "title": "Custom Text",
      "resetToDefault": "Reset to default",
      "loadError": "Error loading custom text settings.",
      "entityName": "Custom text",
      "saveError": "Error saving custom text."
    },
    "feeIndex": {
      "title": "Fees",
      "feesGenerated": "Fees Generated"
    },
    "generalIndex": {
      "pageTitle": "General Settings",
      "informationLocked": "Information Locked",
      "informationLockedBody": "Your organization information, address details, and representatives are currently locked as these details have been verified with Stripe, our payment processor. As regulatory requirements evolve globally, you can expect Stripe's compliance process to evolve along with them. With that in mind, at this time Stripe has shared that this information does not need to be updated annually and at this point is a one-time-only submission process. The only item that is encouraged to be updated is the Representative, who only needs to be updated when the representative changes, not annually. Should you need to update your representative, please reach out to",
      "supportEmailLink": "help{'@'}getcommunal.com",
      "forSupport": "for support.",
      "organizationInformation": "Organization Information",
      "verificationErrors": "Verification Errors",
      "verificationErrorsBody": "The following errors are preventing your account from being verified. Please resolve these errors:",
      "contactInformation": "Contact Information",
      "addressInformation": "Address Information",
      "verificationDocuments": "Verification Documents",
      "additionalVerificationRequired": "Additional verification required",
      "additionalVerificationBody": "Some additional verification documents are required to verify your organization. Please upload the necessary documents below.",
      "directorshipImportant": "IMPORTANT:",
      "directorshipIntro": "The document you upload for",
      "directorshipProofLabel": "Proof of Directorship",
      "directorshipMustContain": "must contain an",
      "directorshipExactMatch": "exact match",
      "directorshipMatchDetail": "of the directors listed under \"Organization Representatives\" below. For example, if you're uploading an Annual Return, make sure the directors listed on that document are identical to those you've entered in the system. If there's any mismatch, Stripe will reject the document. Please",
      "directorshipDoNot": "do not",
      "directorshipUploadMiddle": "upload a document that simply lists your directors. It",
      "directorshipMust": "must",
      "directorshipUploadEnd": "be a document that Stripe supports that contains your directors. Supported documents can be found",
      "here": "here",
      "uploadProofOfRegistration": "Upload Proof Of Registration *",
      "fileTypeError": "Must be a PDF, JPG, JPEG, or PNG file, up to 10MB in size",
      "registrationDescription": "Verify your organization's registration by uploading a document showing proof of registration. PDF, JPG, JPEG, or PNG file, up to 10MB in size.",
      "supportedDocumentsCanBeFoundHere": "Supported documents can be found here",
      "uploadProofOfDirectors": "Upload Proof of Directors *",
      "directorsDescription": "Verify your organization's directors by uploading a document showing proof of directors. PDF, JPG, JPEG, or PNG file, up to 10MB in size.",
      "agreements": "Agreements",
      "iAgreeToThe": "I agree to the",
      "stripeConnectedAccountAgreement": "Stripe Connected Account Agreement",
      "stripeConnectedAccountBody": "Communal uses Stripe Connected Accounts to process payments. In order to do so, you must agree to the Stripe Connected Account Agreement which outlines the terms and conditions for using Stripe's services through third-party platforms.",
      "organizationRepresentatives": "Organization Representatives",
      "configurations": "Configurations",
      "googleMapsLabel": "Use Google Maps integration for address fields",
      "googleMapsDescription": "This will provide users with a dropdown of addresses as they type. Only disable this if most of your users have addresses not available on Google Maps.",
      "enableGoogleMaps": "Enable Google Maps",
      "overdueRemindersLabel": "Send overdue invoice reminders",
      "overdueRemindersDescription": "When enabled, reminders are sent the day after the invoice is due, then weekly until 90 days from the anchor date.",
      "enableOverdueReminders": "Enable overdue reminders",
      "restrictUserRegistration": "Restrict user registration",
      "restrictUserRegistrationDescription": "This will restrict user registration so that only admins can create new accounts.",
      "hideSupportTelephone": "Hide support telephone",
      "hideSupportTelephoneDescription": "This will hide the support telephone number from the public-facing pages.",
      "requireAddressDuringRegistration": "Require address during registration",
      "requireAddressDescription": "This will require users to provide their address information when creating an account. If disabled, users can register with just basic information.",
      "requireAddressOnRegistration": "Require address on registration",
      "familyAccounts": "Family accounts",
      "familyAccountsDescription": "Allows this tenant to invite family members with their own login accounts.",
      "enableFamilyAccounts": "Enable family accounts",
      "defaultProgramGlCode": "Default Program GL Code",
      "defaultProgramGlCodeDescription": "This GL code will be applied to all program transactions unless overridden at the program level.",
      "glCodePlaceholder": "e.g. 4000-100",
      "emailSettings": "Email Settings",
      "note": "Note:",
      "emailSettingsNote": "These settings are effective for most email clients, but for full domain authentication, additional DNS configuration is required. Please contact support to coordinate setup with your IT team.",
      "fromAddressLabel": "From Address",
      "fromAddressDescription": "The email address that outgoing emails will be sent from. Leave blank to use the system default.",
      "fromAddressPlaceholder": "noreply{'@'}yourorganization.com",
      "replyToAddressLabel": "Reply-To Address",
      "replyToAddressDescription": "When recipients reply to emails from your organization, their replies will be sent to this address.",
      "replyToAddressPlaceholder": "info{'@'}yourorganization.com",
      "mailingAddress": "Mailing Address",
      "mailingAddressDescription": "Optional. If set, this address will be used in email footers instead of your physical address. Useful for PO Boxes or other mailing addresses.",
      "clearMailingAddress": "Clear Mailing Address",
      "settings": "Settings",
      "errorSavingSettings": "There was an error saving your settings.",
      "mailingAddressCleared": "Mailing address cleared.",
      "person": "Person"
    },
    "integrations": {
      "title": "Integrations",
      "loading": "Loading integration settings...",
      "loadError": "Unable to load integration settings",
      "providerConnected": "{provider} connected",
      "verifyError": "Unable to verify integration keys",
      "providerDisconnected": "{provider} disconnected",
      "disconnectError": "Unable to disconnect integration"
    },
    "notifications": {
      "title": "Notification Settings"
    },
    "padBankVerification": {
      "heading": "PAD Bank Verification (Micro-deposits)",
      "loadingStatus": "Loading verification status...",
      "bankAccountVerified": "Bank Account Verified",
      "verifiedDescription": "Your Canadian bank account has been verified and is ready for PAD payments.",
      "verifiedLabel": "Verified:",
      "changeBankAccount": "Change Bank Account",
      "changeBankAccountDescription": "If you need to use a different bank account for PAD payments, you can remove the current bank account and add a new one.",
      "removing": "Removing...",
      "removeBankAccount": "Remove Bank Account",
      "microDepositsPending": "Micro-deposits Pending",
      "microDepositsPendingDescription": "Two small deposits have been initiated to your bank account. These typically arrive within 1-2 business days. Once you see them in your bank statement, enter the amounts below to complete verification.",
      "verifyMicroDeposits": "Verify Micro-deposits",
      "verifyMicroDepositsDescription": "Enter the two deposit amounts (in cents) that appeared in your bank account.",
      "firstDeposit": "First Deposit (cents)",
      "firstDepositPlaceholder": "e.g., 32",
      "secondDeposit": "Second Deposit (cents)",
      "secondDepositPlaceholder": "e.g., 45",
      "resetting": "Resetting...",
      "startOver": "Start Over",
      "verifyDeposits": "Verify Deposits",
      "bankDetailsRequired": "Bank Details Required",
      "bankDetailsRequiredDescription": "A verification session was started but bank details were not collected. Please enter your billing details and click below to continue.",
      "billingDetails": "Billing Details",
      "accountHolderName": "Account Holder Name",
      "accountHolderNamePlaceholder": "Full name on bank account",
      "emailAddress": "Email Address",
      "continueBankSetup": "Continue Bank Setup",
      "aboutMicroDepositVerification": "About Micro-deposit Verification",
      "aboutDescription": "Some Canadian banks do not support instant verification. For these banks, we use micro-deposit verification:",
      "step1": "Enter your billing details and bank account information",
      "step2": "Two small deposits (under {'$'}1 each) will be sent to your account",
      "step3": "Once you see the deposits (1-2 business days), return here",
      "step4": "Enter the deposit amounts to verify your account",
      "aboutFooter": "This process ensures you have access to the bank account before we enable PAD payments.",
      "billingDetailsDescription": "Please provide the account holder's name and email address. This information is required by Stripe for PAD authorization.",
      "startBankVerification": "Start Bank Verification",
      "resetVerification": "Reset Verification",
      "confirmRemoveMessage": "Are you sure you want to remove this bank account? This will detach the bank account from Stripe and you will need to add and verify a new bank account to continue using PAD payments.",
      "confirmResetMessage": "Are you sure you want to reset the current verification? This will cancel the current process and allow you to start fresh.",
      "emailPlaceholder": "email{'@'}example.com",
      "pageTitle": "PAD Bank Verification"
    },
    "payoutIndex": {
      "payouts": "Payouts",
      "bankDetails": "Bank Details",
      "communalSendsPayments": "Communal sends payments directly to your bank account. Enter your details below to start receiving payments.",
      "transitNumber": "Transit Number *",
      "institutionNumber": "Institution Number *",
      "routingNumber": "Routing Number *",
      "accountNumber": "Account Number *",
      "confirmAccountNumber": "Confirm Account Number *",
      "confirmAccountNumberFeedback": "This field is required and must match the account number.",
      "iAgreeToThe": "I agree to the",
      "stripeAgreement": "Stripe Connected Account Agreement",
      "acceptTermsToReceivePayouts": "Your bank details have been saved. Please accept the Stripe Connected Account Agreement to start receiving payouts.",
      "bankDetailsSavedPayout": "Your bank details have been saved. Payouts will be processed to an account ending in",
      "history": "History",
      "bankDetailsSavedSuccess": "Bank details saved successfully.",
      "bankDetailsSaveError": "There was an error saving your bank details.",
      "tosSavedSuccess": "Terms of service acceptance saved successfully.",
      "tosSaveError": "There was an error saving your TOS acceptance."
    },
    "pollingSettings": {
      "title": "Polling Settings",
      "general": "General",
      "enablePolling": "Enable Polling",
      "endpointUrl": "Endpoint URL",
      "rateLimit": "Rate Limit (req/min)",
      "concurrencyPerBatch": "Concurrency Per Batch",
      "activeWindow": "Active Window",
      "activeWindowDescription": "Requests will start after the configured start time and complete as many as possible within the configured end time.",
      "startTime": "Start (HH:mm)",
      "endTime": "End (HH:mm)",
      "authentication": "Authentication",
      "authType": "Auth Type",
      "noAuthentication": "No Authentication",
      "basicAuth": "Basic Auth",
      "bearerToken": "Bearer Token",
      "username": "Username",
      "enterUsername": "Enter username",
      "password": "Password",
      "enterPassword": "Enter password",
      "token": "Token",
      "enterApiToken": "Enter API token",
      "enterBearerToken": "Enter bearer token",
      "testing": "Testing...",
      "testEndpoint": "Test Endpoint",
      "timeFormatMessage": "Time must be in HH:mm or HH:mm:ss format.",
      "urlPlaceholderMessage": "URL contains invalid placeholder format. Use {'{'}{'{'}field_name{'}'}{'}'} syntax.",
      "settingsSaved": "Polling settings saved",
      "unableToSave": "Unable to save polling settings",
      "endpointReachable": "Endpoint is reachable! ({code})",
      "endpointError": "Endpoint returned error: {code}",
      "noUsersToTest": "Cannot test endpoint: No users found in the system. Add users first to test dynamic placeholders.",
      "testFailed": "Test failed",
      "unableToTest": "Unable to test endpoint"
    },
    "verificationUpload": {
      "pageTitle": "Representative Verification",
      "selectRepresentativeHelp": "Select the representative whose verification documents you are uploading. If you do not see the representative you are looking for, please contact us.",
      "representativeLabel": "Representative",
      "selectTypeHelp": "Select the type of verification document you are uploading.",
      "verificationTypeLabel": "Verification Type",
      "addressDocument": "Address Document",
      "frontOfId": "Front of ID",
      "useMyCamera": "Use My Camera",
      "uploadPdfOrImage": "Upload PDF or Image",
      "uploadAFile": "Upload a File",
      "fileTypeHint": "PDF, JPG, JPEG, or PNG file, up to 10MB in size",
      "fileLabel": "File:",
      "pdfDocument": "PDF document",
      "additionalAddressDocument": "Additional Address Document (Optional)",
      "backOfId": "Back of ID",
      "uploadPdfOrImageOptional": "Upload PDF or Image (Optional)",
      "additionalAddressHint": "Optional: Additional address document if needed",
      "addressDocumentBack": "Address Document Back",
      "takeAPhoto": "Take a Photo",
      "positionIdCard": "Position your ID card within the frame",
      "captured": "Captured",
      "capture": "Capture",
      "proofOfId": "Proof of ID",
      "proofOfAddress": "Proof of Address",
      "failedToLoadRepresentatives": "Failed to load representatives. Please refresh the page.",
      "completeFieldsAddress": "Please complete all required fields and upload the address document.",
      "completeFieldsImages": "Please complete all required fields and upload both images.",
      "uploadSuccess": "Verification documents uploaded successfully!",
      "uploadFailed": "Failed to upload verification documents. Please try again.",
      "headTitle": "Verification Upload"
    },
    "onboardingChecklist": {
      "welcomeTitle": "✨ Welcome to Communal ✨",
      "efclIntro": "The EFCL and Communal have launched a new partnership to help you manage your community league. We're excited to have you on board. Here's a list of things you can do to get started.",
      "intro": "We're thrilled to have you on board! To help you get started, we've outlined a few key steps below to begin setting up your site:",
      "watchVideo": "Watch Video",
      "helpArticle": "Help Article",
      "needHelp": "Need help? Visit our robust",
      "helpCenter": "Help Center",
      "or": "or"
    },
    "requirementsBanner": {
      "actionRequiredHeading": "Action Required: Complete Stripe Verification Process",
      "complianceInfo": "Stripe must collect information from your organization to maintain compliance with government regulations around processing funds online. Learn more here:",
      "canadaLink": "Canada",
      "usaLink": "USA",
      "newCustomerInfo": "If you are a new customer you will need to complete the requirements listed below before you are able to process funds online.",
      "longtimeCustomerInfo": "If you are a longtime customer and you are seeing this banner Stripe is requiring additional information from your organization. The additional information or updates required are listed below. Failure to complete these Stripe requirements within 14 days will result in paused payouts and potentially paused payment processing.",
      "moreInfoLead": "For more information on how to complete these requirements please review our",
      "complianceGuideLink": "regulation compliance guide",
      "helpLead": "We would love to help you complete Stripe's verification process so please email",
      "forSupportOr": "for support or",
      "bookMeetingLink": "book a meeting",
      "clientServicesTrailing": "with our Client Services Specialist.",
      "outstandingRequirements": "Your current outstanding requirements are below:",
      "pendingHeading": "Thank you for submitting your requirements",
      "pendingInfo": "Stripe is currently reviewing your account. Please check back periodically to see if any new verification requirements are present. Once all verification checks have passed, you will see a green banner on the dashboard confirming verification is complete.",
      "verifiedHeading": "Your Communal account has been verified!",
      "verifiedInfo": "We thank you for complying with these verification requirements and apologize for the inconvenience it may have caused.",
      "supportEmail": "help{'@'}getcommunal.com"
    },
    "representativeForm": {
      "contact": "Contact",
      "required": "Required",
      "firstNameLabel": "First name *",
      "firstNamePlaceholder": "First name",
      "lastNameLabel": "Last name *",
      "lastNamePlaceholder": "Last name",
      "emailLabel": "Email *",
      "emailPlaceholder": "Email",
      "phoneLabel": "Phone *",
      "address": "Address",
      "organizationRole": "Organization role",
      "roleLabel": "Role *",
      "roleInvalidFeedback": "You must have at least one role. You can only have one representative. If you need to change the representative, please contact support.",
      "representativeTerm": "Representative:",
      "representativeTermDescription": "Primary authorized person to provide account information. (Only one person can be denoted as representative)",
      "directorTerm": "Director:",
      "directorTermDescription": "Member of governing board or ensures regulatory compliance.",
      "executiveTerm": "Executive:",
      "executiveTermDescription": "Controls, manages, or directs the organization.",
      "ownerTerm": "Owner:",
      "ownerTermDescription": "Has ownership stake in the legal entity.",
      "titleLabel": "Title *",
      "titleDescription": "The job title or position of the person at your organization.",
      "dateOfBirthLabelRequired": "Date of Birth *",
      "dateOfBirthLabel": "Date of Birth",
      "roleRepresentative": "Representative",
      "roleDirector": "Director",
      "roleOwner": "Owner",
      "roleExecutive": "Executive",
      "dobInPast": "Date of birth must be in the past.",
      "dobMinAge": "You must be at least 13 years old.",
      "phoneInvalid": "Enter a valid phone number.",
      "entity": "Representative"
    },
    "representativeTable": {
      "addPerson": "Add person",
      "verificationErrorsTitle": "Representative Verification Errors",
      "verifyDirectorsTitle": "Verify Directors",
      "importantLabel": "Important:",
      "verifyDirectorsInfo": "Please ensure this list includes all current directors of your organization. This information will be verified against public records (e.g., annual returns). If there are discrepancies, you may need to provide an updated document (like a recent Annual Return) to confirm the current directorship. Once the list is complete and accurate, click \"Verify\" to proceed.",
      "unsureIntro": "If you're unsure about any of the information provided, please reach out to",
      "guidanceOutro": "for guidance.",
      "verify": "Verify",
      "confirmDirectorsIntro": "Confirm that",
      "emphasisAll": "all",
      "confirmDirectorsBody": "current directors are listed below. This list should match your most recent official documents. Please add or remove directors as needed from the below list. If recent changes aren't reflected in public records, be prepared to provide updated documentation. Inaccuracies may require additional verification steps. Only click \"Confirm\" when you're certain the list is complete and accurate.",
      "confirm": "Confirm",
      "completeVerification": "Complete verification",
      "uploadDocument": "Upload document",
      "notApplicable": "N/A",
      "editPersonTitle": "Edit Person",
      "addPersonTitle": "Add Person",
      "supportEmail": "help{'@'}getcommunal.com",
      "directorsVerified": "Directors verified!",
      "verifyDirectorsFailed": "Failed to verify directors."
    },
    "moduleUpsell": {
      "notAvailable": "This module is not available on your account yet. Get in touch and we will be happy to unlock it for you.",
      "learnMore": "Learn more",
      "contactUs": "Contact us",
      "unlockTitle": "Unlock {title}",
      "unlockModule": "Unlock Module"
    },
    "checklistEdit": {
      "editChecklist": "Edit Checklist"
    },
    "pdfMembershipCard": {
      "pxUnit": "px"
    }
  },
  "user": {
    "apiKeySettings": {
      "title": "API Keys",
      "seeOur": "See our",
      "apiDocumentation": "API documentation",
      "endpointsUsageGuides": "for available endpoints and usage guides."
    },
    "formSubmissions": {
      "title": "My Forms",
      "formResponse": "Form Response",
      "submitted": "Submitted",
      "noResponseData": "No response data available.",
      "resubmitForm": "Resubmit Form",
      "submitNewResponse": "Submit New Response",
      "unableToLocateForm": "Unable to locate the latest version of this form.",
      "formNoLongerAvailable": "This form is no longer available for resubmission.",
      "formSingleSubmissionOnly": "This form is configured to only allow one submission.",
      "unableToLoadForm": "Unable to load the latest form version. Please try again.",
      "unableToSubmitForm": "Unable to submit the form. Please try again.",
      "unableToDetermineForm": "Unable to determine which form to submit.",
      "formResubmitted": "Form resubmitted successfully.",
      "response": "Response"
    },
    "generalSettings": {
      "generalSettings": "General Settings",
      "personalDetails": "Personal Details",
      "firstName": "First Name *",
      "fieldRequired": "This field is required.",
      "lastName": "Last Name *",
      "middleName": "Middle Name",
      "preferredName": "Preferred Name",
      "dateOfBirth": "Date of Birth",
      "contactDetails": "Contact Details",
      "email": "Email *",
      "emailVerifiedHelp": "Verified through your sign-in account. To change it, update your account email and your tenant email will follow.",
      "phoneNumber": "Phone Number",
      "address": "Address",
      "additionalInformation": "Additional information",
      "changePassword": "Change Password",
      "displayPreferences": "Display Preferences",
      "locale": "Locale",
      "localeDescription": "Controls how currency amounts are displayed (e.g., {'$'}1,234.56 vs 1.234,56 €).",
      "deleteAccount": "Delete Account",
      "deleteAccountContact": "If you would like to delete your account, please contact us at",
      "deleteAccountEmail": "help{'@'}getcommunal.com",
      "deleteAccountRemoval": ". We will remove all of your data from our system within 30 days.",
      "pageTitle": "Settings",
      "automaticLocale": "Automatic (based on your address)",
      "userEntity": "User",
      "saveError": "An error occurred while saving your settings."
    },
    "notificationSettings": {
      "title": "Notification Settings",
      "emailNotificationsDescription": "Controls announcements and newsletter-style notifications from your organization.",
      "receiveEmailNotifications": "I would like to receive email notifications",
      "programNotifications": "Program Notifications",
      "receiveProgramCancellationNotifications": "Receive program cancellation notifications",
      "invoiceNotifications": "Invoice Notifications",
      "receiveInvoicePaymentNotifications": "Receive invoice payment notifications",
      "transactionNotifications": "Transaction Notifications",
      "receiveTransactionCompletedNotifications": "Receive transaction completed notifications",
      "chargebackNotifications": "Chargeback Notifications",
      "receiveChargebackNotifications": "Receive chargeback notifications",
      "bookingNotifications": "Booking Notifications",
      "receiveBookingNotifications": "Receive booking notifications",
      "savedEntity": "User",
      "saveError": "An error occurred while saving your settings."
    },
    "paymentSettings": {
      "title": "Payment Settings",
      "cardUpdated": "Payment card updated."
    },
    "waiverAgreements": {
      "waiverUnavailable": "Waiver unavailable"
    }
  }
}
